import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import { useCallback } from 'react';
import styled from '@xstyled/styled-components';
import { Checkbox, Space } from 'antd';
import { BaseQuestionPreview } from './base-question-preview.component';
import { styleVariables } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
var AnswerItem = styled(Checkbox)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  .ant-checkbox + span {\n    width: 100%;\n    padding-right: 0;\n  }\n  .ant-input-affix-wrapper {\n    border-radius: 4px !important;\n  }\n  .ant-checkbox-checked .ant-checkbox-inner {\n    background: ", ";\n  }\n  .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {\n    border-color: white !important;\n  }\n"])), styleVariables.colors.blue4);
var AnswerGroup = styled(Checkbox.Group)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
export var MultipleChoiceQuestionPreview = function MultipleChoiceQuestionPreview(props) {
  var question = props.question,
      index = props.index,
      previewMode = props.previewMode,
      onEditQuestion = props.onEditQuestion,
      sectionIndexSelected = props.sectionIndexSelected,
      submissionMode = props.submissionMode,
      onSubmitAnswer = props.onSubmitAnswer,
      defaultAnswer = props.defaultAnswer,
      disabled = props.disabled,
      active = props.active;
  var onFieldsChange = useCallback(function (checkedValues) {
    submissionMode && onSubmitAnswer(checkedValues);
  }, [onSubmitAnswer, submissionMode]);

  var MultipleChoiceQuestionPreviewRender = function MultipleChoiceQuestionPreviewRender(props) {
    var defaultValue = props.defaultValue;
    return /*#__PURE__*/_jsx(BaseQuestionPreview, {
      index: index,
      question: question,
      submissionMode: submissionMode,
      previewMode: previewMode,
      active: active,
      children: /*#__PURE__*/_jsx(AnswerGroup, {
        disabled: disabled,
        defaultValue: defaultValue || defaultAnswer,
        onChange: onFieldsChange,
        children: /*#__PURE__*/_jsx(Space, {
          direction: "vertical",
          children: question.answers.map(function (a, index) {
            return /*#__PURE__*/_jsx(AnswerItem, {
              value: a.id,
              disabled: isDisable,
              onChange: onChange,
              children: a.description
            }, index);
          })
        })
      })
    });
  };

  if (!(question !== null && question !== void 0 && question.correctAnswers)) {
    return /*#__PURE__*/_jsx(MultipleChoiceQuestionPreviewRender, {});
  }

  var isDisable = !previewMode;

  var onChange = function onChange() {
    onEditQuestion(sectionIndexSelected, index);
  };

  return /*#__PURE__*/_jsx(MultipleChoiceQuestionPreviewRender, {
    defaultValue: !previewMode && question.correctAnswers.map(function (c) {
      return c.answerId;
    })
  });
};